import { useState } from 'react';

export type AsinCatalogMeta = {
  title?: string | null;
  imageUrl?: string | null;
};

export type AsinCatalog = Map<string, AsinCatalogMeta>;

export function catalogKey(asin?: string | null): string {
  return (asin || '').trim().toUpperCase();
}

export function buildAsinCatalog(
  rows: Array<{ asin?: string | null; title?: string | null; imageUrl?: string | null }>
): AsinCatalog {
  const map: Map<string, AsinCatalogMeta> = new Map();
  for (const row of rows) {
    const key = catalogKey(row.asin);
    if (!key) continue;
    map.set(key, { title: row.title, imageUrl: row.imageUrl });
  }
  return map;
}

function AsinThumb({ src, alt }: { src?: string | null; alt: string }) {
  const [failed, setFailed] = useState(false);
  const showImage = Boolean(src) && !failed;

  return (
    <div className="app-table-identity-thumb" aria-hidden={!showImage}>
      {showImage ? <img src={src!} alt={alt} onError={() => setFailed(true)} /> : null}
    </div>
  );
}

export function AsinIdentity({
  asin,
  title,
  imageUrl,
  catalog,
}: {
  asin?: string | null;
  title?: string | null;
  imageUrl?: string | null;
  catalog?: AsinCatalog;
}) {
  const asinLabel = (asin || '').trim();
  const meta = catalog && asinLabel ? catalog.get(catalogKey(asinLabel)) : undefined;
  const name = (title || meta?.title || '').trim();
  const src = imageUrl || meta?.imageUrl || null;
  if (!asinLabel && !name) return <span>—</span>;

  const heading = name || asinLabel;

  return (
    <div className="app-table-identity">
      <AsinThumb src={src} alt={heading} />
      <div className="app-table-identity-copy">
        <div className="app-table-identity-title text-sm text-foreground" title={heading}>
          {heading}
        </div>
        {name && asinLabel && asinLabel !== name ? (
          <div className="app-table-identity-asin font-mono text-xs text-foreground-muted">
            {asinLabel}
          </div>
        ) : null}
      </div>
    </div>
  );
}
